var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00244141,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#33C189"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0024 19.2526C20.0024 19.4509 19.9205 19.6409 19.7746 19.7811C19.6288 19.9213 19.4309 20 19.2247 20H6.78022C6.57394 20 6.37611 19.9213 6.23025 19.7811C6.08439 19.6409 6.00244 19.4509 6.00244 19.2526V11.3979C6.00236 11.284 6.02937 11.1716 6.0814 11.0693C6.13343 10.967 6.20911 10.8774 6.30266 10.8075L12.5249 6.15746C12.6614 6.05541 12.8295 6 13.0024 6C13.1754 6 13.3435 6.05541 13.48 6.15746L19.7022 10.8075C19.7958 10.8774 19.8715 10.967 19.9235 11.0693C19.9755 11.1716 20.0025 11.284 20.0024 11.3979V19.2526ZM12.2247 14.0211V18.5053H13.7802V14.0211H12.2247Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.792ce6e47c458ecc717037a8784b9e37.svg";
export { ForwardRef as ReactComponent };